import { css } from "styled-components";
import { darken } from "polished";
import { color, onHover } from "./helpers";
const fontFamilies = {
    base: `"Nunito", -apple-system, system-ui, BlinkMacSystemFont, Roboto, Segoe UI, Oxygen Sans, Ubuntu, Helvetica Nue, sans-serif`
};
export const typeStyleProperties = {
    base: { fontSize: 16, lineHeight: 1.375, fontWeight: 400 },
    link: null,
    displayL: { fontSize: 68, lineHeight: 1, fontWeight: 400 },
    displayM: { fontSize: 44, lineHeight: 1, fontWeight: 700 },
    displayS: { fontSize: 28, lineHeight: 1, fontWeight: 400 },
    headerXL: { fontSize: 32, lineHeight: 1.0625, fontWeight: 400 },
    headerL: { fontSize: 24, lineHeight: 1.33, fontWeight: 600 },
    headerM: { fontSize: 20, lineHeight: 1.2, fontWeight: 700 },
    headerS: { fontSize: 18, lineHeight: 1.33, fontWeight: 700 },
    subHeaderM: { fontSize: 16, lineHeight: 1.375, fontWeight: 700 },
    subHeaderS: { fontSize: 14, lineHeight: 1.42857, fontWeight: 700 },
    dataL: { fontSize: 36, lineHeight: 1, fontWeight: 700 },
    dataM: { fontSize: 28, lineHeight: 1, fontWeight: 700 },
    dataS: { fontSize: 16, lineHeight: 1.375, fontWeight: 700 },
    bodyL: { fontSize: 16, lineHeight: 1.375, fontWeight: 400 },
    bodyM: { fontSize: 14, lineHeight: 1.42857, fontWeight: 700 },
    bodyS: { fontSize: 14, lineHeight: 1.42857, fontWeight: 400 },
    actionM: { fontSize: 14, lineHeight: 1.142857, fontWeight: 700 },
    actionS: { fontSize: 12, lineHeight: 1.5, fontWeight: 700 },
    labelL: { fontSize: 14, lineHeight: 1.42857, fontWeight: 700 },
    labelM: { fontSize: 14, lineHeight: 1.42857, fontWeight: 400 },
    captionM: { fontSize: 12, lineHeight: 1.5, fontWeight: 400 },
    captionS: { fontSize: 10, lineHeight: 1.6, fontWeight: 600 }
};
const typeStyles = {
    base: `
    font-family: ${fontFamilies.base};
    font-weight: ${typeStyleProperties.base.fontWeight};
    `,
    link: css `
    color: ${color("typeLink")};
    text-decoration: none;
    transition: color 0.2s ease;

    ${onHover(css `
      color: ${(props) => darken(0.15, color("typeLink")(props))};
      text-decoration: underline;
    `)}
  `,
    displayL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.displayL.fontWeight};
      font-size: ${typeStyleProperties.displayL.fontSize}px;
      line-height: ${typeStyleProperties.displayL.lineHeight};
    `,
    displayM: `
      font-family:${fontFamilies.base};
      font-weight: ${typeStyleProperties.displayM.fontWeight};
      font-size: ${typeStyleProperties.displayM.fontSize}px;
      line-height: ${typeStyleProperties.displayM.lineHeight};
    `,
    displayS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.displayS.fontWeight};
      font-size: ${typeStyleProperties.displayS.fontSize}px;
      line-height: ${typeStyleProperties.displayS.lineHeight};
    `,
    headerXL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.headerXL.fontWeight};
      font-size: ${typeStyleProperties.headerXL.fontSize}px;
      line-height: ${typeStyleProperties.headerXL.lineHeight};
    `,
    headerL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.headerL.fontWeight};
      font-size: ${typeStyleProperties.headerL.fontSize}px;
      line-height: ${typeStyleProperties.headerL.lineHeight};
    `,
    headerM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.headerM.fontWeight};
      font-size: ${typeStyleProperties.headerM.fontSize}px;
      line-height: ${typeStyleProperties.headerM.lineHeight};
    `,
    headerS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.headerS.fontWeight};
      font-size: ${typeStyleProperties.headerS.fontSize}px;
      line-height: ${typeStyleProperties.headerS.lineHeight};
    `,
    subHeaderM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.subHeaderM.fontWeight};
      font-size: ${typeStyleProperties.subHeaderM.fontSize}px;
      line-height: ${typeStyleProperties.subHeaderM.lineHeight};
    `,
    subHeaderS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.subHeaderS.fontWeight};
      font-size: ${typeStyleProperties.subHeaderS.fontSize}px;
      line-height: ${typeStyleProperties.subHeaderS.lineHeight};
    `,
    dataL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.dataL.fontWeight};
      font-size: ${typeStyleProperties.dataL.fontSize}px;
      line-height: ${typeStyleProperties.dataL.lineHeight};
    `,
    dataM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.dataM.fontWeight};
      font-size: ${typeStyleProperties.dataM.fontSize}px;
      line-height: ${typeStyleProperties.dataM.lineHeight};
    `,
    dataS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.dataS.fontWeight};
      font-size: ${typeStyleProperties.dataS.fontSize}px;
      line-height: ${typeStyleProperties.dataS.lineHeight};
    `,
    bodyL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.bodyL.fontWeight};
      font-size: ${typeStyleProperties.bodyL.fontSize}px;
      line-height: ${typeStyleProperties.bodyL.lineHeight};
    `,
    bodyM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.bodyM.fontWeight};
      font-size: ${typeStyleProperties.bodyM.fontSize}px;
      line-height: ${typeStyleProperties.bodyM.lineHeight};
    `,
    bodyS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.bodyS.fontWeight};
      font-size: ${typeStyleProperties.bodyS.fontSize}px;
      line-height: ${typeStyleProperties.bodyS.lineHeight};
    `,
    actionM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.actionM.fontWeight};
      font-size: ${typeStyleProperties.actionM.fontSize}px;
      line-height: ${typeStyleProperties.actionM.lineHeight};
    `,
    actionS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.actionS.fontWeight};
      font-size: ${typeStyleProperties.actionS.fontSize}px;
      line-height: ${typeStyleProperties.actionS.lineHeight};
  `,
    labelL: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.labelL.fontWeight};
      font-size: ${typeStyleProperties.labelL.fontSize}px;
      line-height: ${typeStyleProperties.labelL.lineHeight};
    `,
    labelM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.labelM.fontWeight};
      font-size: ${typeStyleProperties.labelM.fontSize}px;
      line-height: ${typeStyleProperties.labelM.lineHeight};
    `,
    captionM: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.captionM.fontWeight};
      font-size: ${typeStyleProperties.captionM.fontSize}px;
      line-height: ${typeStyleProperties.captionM.lineHeight};

    `,
    captionS: `
      font-family: ${fontFamilies.base};
      font-weight: ${typeStyleProperties.captionS.fontWeight};
      font-size: ${typeStyleProperties.captionS.fontSize}px;
      line-height: ${typeStyleProperties.captionS.lineHeight};
    `
};
export const typography = {
    fontFamilies,
    typeStyles
};
